import { render, staticRenderFns } from "./SOOrderListButton.vue?vue&type=template&id=2323a1dd&"
import script from "./SOOrderListButton.vue?vue&type=script&lang=ts&"
export * from "./SOOrderListButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports